import { RootState } from "src/reducers";
import { connect, ConnectedProps } from 'react-redux';
import { TermDepositList } from "./components/list";
import { expiringTermDepositsSlice } from "../store/slice";
import { selectExpiringTermDepositList, selectParameters, selectTermDepositParameters,  } from "../store/selectors";
import { progressSelectorFactory } from '../../../common';
import { ExpiringTermDepositsListActionTypes } from "../store/thunks";

const actionTypes = [ExpiringTermDepositsListActionTypes.FetchExpiringTermDepositslList];

const mapStateToProps = (state: RootState) => ({
  termDepositList: selectExpiringTermDepositList(state),
  loadingProgress: progressSelectorFactory(actionTypes)(state),
  parameters: selectParameters(state),
  termDepsoitParameters: selectTermDepositParameters(state), 
});

const mapDispatchToProps = {
  ...expiringTermDepositsSlice.actions
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const TermDepositListStateContainer = connect(mapStateToProps, mapDispatchToProps)(TermDepositList);